export default "__VITE_ASSET__b9c59427__"